import React from 'react';

export interface NoticeboxProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Notice content
   */
  children: React.ReactNode;
  /**
   * Custom CSS classes
   */
  className?: string;
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
  /**
   * HTML id attribute
   */
  id?: string;
}

export const Noticebox: React.FC<NoticeboxProps> = ({
  children,
  className = '',
  style,
  id,
  ...rest
}) => {
  const baseClass = 'hi-ui-noticebox';
  const allClasses = `${baseClass} ${className}`.trim();

  return (
    <div className={allClasses} style={style} id={id} {...rest}>
      {children}
    </div>
  );
};
